import { useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { ChessBoard } from '@exports/ChessBoard';
import { isPlayableFen } from '@libs/chess/validateFen';
import { FormInput, FormLabel, FormRow } from '@ui/components/Form/Form';
import { Input } from '@ui/components/Input';

import { TournamentEditFormValues } from '@features/tournament/ui/components/TournamentSettings/typings';

import styles from './InitialFenInput.module.css';

export function InitialFenInput() {
  const { control, watch } = useFormContext<TournamentEditFormValues>();
  const fenValue = watch('initialFen');

  const isValidFen = useMemo(() => {
    if (!fenValue) return false;
    return isPlayableFen(fenValue);
  }, [fenValue]);

  return (
    <FormRow>
      <FormLabel hint="FEN">Начальная позиция</FormLabel>
      <FormInput>
        <Controller
          name="initialFen"
          control={control}
          render={({ field: { value, onChange, disabled } }) => (
            <div className={styles.stack}>
              <Input
                invisible
                value={value || ''}
                onChange={onChange}
                disabled={disabled}
                placeholder="Стандартная позиция"
              />
              {value && !isValidFen && <p className={styles.error}>Неверный FEN</p>}
              {value && isValidFen && (
                <div className={styles.preview}>
                  <ChessBoard
                    orientation="white"
                    position={value}
                    interactive="none"
                    notation="outside"
                    noAnimation
                    noShadow
                  />
                </div>
              )}
            </div>
          )}
        />
      </FormInput>
    </FormRow>
  );
}
